import { combineReducers } from "@reduxjs/toolkit";

import {
	archivesPushHistoryDataState,
	archivesPushHistoryDataReducer,
	archivesPushHistoryDataAction,
} from "./data";

export type StatePushHistory = {
	data: archivesPushHistoryDataState;
};

export const pushHistory = combineReducers<StatePushHistory>({
	data: archivesPushHistoryDataReducer,
});

export const archivesPushHistoryAction = {
	data: archivesPushHistoryDataAction,
};

export default pushHistory;
